import { createFileRoute } from "@tanstack/react-router";
import { AttributionsPage } from "@/features/attributions/AttributionsPage";
export const Route = createFileRoute("/attributions")({ component: AttributionsPage });
